// extracted by mini-css-extract-plugin
module.exports = {"container":"GrayBackground_container__mnpGT","wrapper":"GrayBackground_wrapper__4tLmk","title":"GrayBackground_title__xMtQJ"};